import React from 'react'
import { useSelector } from 'react-redux'
import SamgovSearchView from 'components/QuickSearch/SAMGOV/SamgovSearchView'

const SamgovTabContent = ({ applicantId }) => {
    // Pull the business + owners from the already-loaded application in redux.
    // We expose these as "prefill targets" so the user can flip between searching for
    // the business and each individual owner with one click.
    const businessName = useSelector(state => state?.applicant?.applicantById?.business?.name)
    const owners = useSelector(state => state?.applicant?.applicantById?.owners) || []

    const prefillTargets = {
        business: businessName || null,
        owners: owners
            .filter(o => o?.firstName || o?.lastName)
            .map(o => ({
                firstName: o.firstName || '',
                middleName: o.middleName || '',
                lastName: o.lastName || '',
                label: [o.firstName, o.lastName].filter(Boolean).join(' ') || 'Owner'
            })),
    }

    return (
        <div className='m-3'>
            <SamgovSearchView
                isQuickSearch={false}
                applicantId={applicantId}
                prefillTargets={prefillTargets}
            />
        </div>
    )
}

export default SamgovTabContent
